import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoPopUpDialogComponent } from './info-pop-up-dialog/info-pop-up-dialog.component';
import { AppService } from '../../services/app.service';

@Component({
    selector: 'app-info-pop-up',
    standalone: true,
    imports: [],
    template: '',
})
export class InfoPopUpComponent implements OnInit {
    public readonly localStorageKey = 'qa_info_popups_seen';

    constructor(public dialog: MatDialog, private appService: AppService) {}

    ngOnInit() {
        const popups = this.appService.getPopups();
        const seen = this.getSeenPopups();
        const notSeen = popups.filter((popup) => !seen.includes(popup));
        if (notSeen.length) {
            this.openPopUpDialog(notSeen);
        }
    }

    private openPopUpDialog(ids: string[]) {
        this.dialog
            .open(InfoPopUpDialogComponent, {
                panelClass: 'dialog-small',
                disableClose: true,
                autoFocus: false,
            })
            .afterClosed()
            .subscribe((closed) => {
                if (closed) {
                    this.setPopupSeen(ids);
                }
            });
    }

    private getSeenPopups(): string[] {
        const item = localStorage.getItem(this.localStorageKey);
        return item ? JSON.parse(item) : [];
    }

    private setPopupSeen(ids: string[]) {
        const seen = this.getSeenPopups();
        const newValue = [...new Set([...seen, ...ids])];
        localStorage.setItem(this.localStorageKey, JSON.stringify(newValue));
    }
}
